<template>
  <v-dialog v-model="c_dialog" width="960">
    <v-card>

      <v-toolbar class="primary white--text" flat dark>
        <v-toolbar-title>Actualizare în masă de pret</v-toolbar-title>
        <v-spacer/>
        <v-btn icon @click="c_dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-1">

        <v-row no-gutters>

          <v-col cols="12">
            <div class="subtitle-1 font-weight-bold ma-1">
              Camere
            </div>
          </v-col>

          <v-col cols="12">
            <v-row no-gutters align="center">
              <v-item-group v-model="c_selected_rooms" multiple>
                <v-item v-for="room in c_available_rooms" v-slot:default="{ active, toggle }" :key="room.id" :value="room.id">
                  <v-btn depressed small :color="active ? 'primary':''" class="ma-1" @click="toggle">{{room.name}}<small class="ml-1">({{room.id}})</small></v-btn>
                </v-item>
              </v-item-group>
            </v-row>
          </v-col>
        </v-row>

        <v-row no-gutters v-if="c_selected_rooms.length">
          <v-col cols="12">
            <div class="subtitle-1 font-weight-bold ma-1">
              Planuri tarifare
            </div>
          </v-col>
          <v-col cols="12">
            <v-row no-gutters align="center">
              <v-item-group v-model="c_selected_rates" multiple>
                <v-item v-for="rate in c_available_rates" v-slot:default="{ active, toggle }" :key="rate.id" :value="rate.id">
                  <v-btn v-if="rate.static.editable_pricings" depressed small :color="active ? 'primary':'' " class="ma-1" @click="toggle">{{rate.name}}<small class="ml-1">({{rate.id}})</small></v-btn>
                </v-item>
              </v-item-group>
            </v-row>
          </v-col>
        </v-row>

        <v-row no-gutters v-if="c_selected_rooms.length && c_selected_rates.length">
          <v-col cols="12">
            <div class="subtitle-1 font-weight-bold ma-1">
              Interval
            </div>
          </v-col>
          <v-col cols="12">
            <v-menu v-model="menu" :close-on-content-click="false" transition="fade-transition" offset-y max-width="512">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="c_label" v-on="on" dense class="ma-1" label="Interval" outlined readonly hide-details/>
              </template>
              <v-card tile flat>
                <im-date-picker v-model="c_value" mode="range" locale="ro" is-inline style="border-width: 0;" :columns="2"/>
                <v-divider class="mx-2"/>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn depressed color="primary" @click="menu=false">
                    Ok
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-col>
          <v-col cols="12">
            <v-row no-gutters align="center">
              <v-item-group v-model="days" multiple>
                <v-item v-for="day in weekdays" v-slot:default="{ active, toggle }" :key="day">
                  <v-btn depressed small :color="active ? 'primary' : ''" class="ma-1" @click="toggle">{{day}}</v-btn>
                </v-item>
              </v-item-group>
            </v-row>
          </v-col>
        </v-row>

        <v-row no-gutters v-if="c_selected_rooms.length && c_selected_rates.length && days.length">

          <v-col cols="12">
            <div class="subtitle-1 font-weight-bold ma-1">
              Valori
            </div>
          </v-col>

          <v-col cols="12">
            <v-row no-gutters>
              <v-col cols="4">
                <div class="ma-1">
                  <v-btn :class="{primary: !price_read_only}" depressed block style="height: 40px; font-size: small" @click="price_read_only = !price_read_only; price = null">
                    Pret
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="8">
                <v-text-field v-model="price" label="Pret" type="number" class="ma-1" outlined dense hide-details :disabled="price_read_only"/>
              </v-col>
            </v-row>
          </v-col>

          <v-row no-gutters>
            <v-col cols="4">
              <div class="ma-1">
                <v-btn :class="{primary: !stop_sell_read_only}" depressed block style="height: 40px; font-size: small" @click="stop_sell_read_only = !stop_sell_read_only; stop_sell = null">
                  Stop Sell
                </v-btn>
              </div>
            </v-col>
            <v-col cols="8">
              <v-select v-model="stop_sell" label="Stop Sell" class="ma-1" outlined dense hide-details :disabled="stop_sell_read_only" :items="[{text: 'Vinde', value: false}, {text: 'Nu Vinde', value: true}]"/>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="4">
              <div class="ma-1">
                <v-btn :class="{primary: !closed_read_only}" depressed block style="height: 40px; font-size: small" @click="closed_read_only = !closed_read_only; closed_arrival = null; closed_departure = null">
                  Inchis
                </v-btn>
              </div>
            </v-col>
            <v-col cols="4">
              <v-select v-model="closed_arrival" label="Sosire" class="ma-1" outlined dense hide-details :disabled="closed_read_only" :items="[{text: 'Deschis', value: false}, {text: 'Inchis', value: true}]"/>
            </v-col>
            <v-col cols="4">
              <v-select v-model="closed_departure" label="Plecare" class="ma-1" outlined dense hide-details :disabled="closed_read_only" :items="[{text: 'Deschis', value: false}, {text: 'Inchis', value: true}]"/>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="4">
              <div class="ma-1">
                <v-btn :class="{primary: !inventory_read_only}" depressed block style="height: 40px; font-size: small" @click="inventory_read_only = !inventory_read_only; min_inventory = null; max_inventory = null">
                  Inventar
                </v-btn>
              </div>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="min_inventory" label="Min" type="number" class="ma-1" outlined dense hide-details :disabled="inventory_read_only"/>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="max_inventory" label="Max" type="number" class="ma-1" outlined dense hide-details :disabled="inventory_read_only"/>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="4">
              <div class="ma-1">
                <v-btn :class="{primary: !stay_through_read_only}" depressed block style="height: 40px; font-size: small" @click="stay_through_read_only = !stay_through_read_only; min_stay_through = null; max_stay_through = null">
                  Durata sejurului după sosire
                </v-btn>
              </div>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="min_stay_through" label="Min" type="number" class="ma-1" outlined dense hide-details :disabled="stay_through_read_only"/>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="max_stay_through" label="Max" type="number" class="ma-1" outlined dense hide-details :disabled="stay_through_read_only"/>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="4">
              <div class="ma-1">
                <v-btn :class="{primary: !stay_read_only}" depressed block style="height: 40px; font-size: small" @click="stay_read_only = !stay_read_only; min_stay_arrival = null; max_stay = null">
                  Durata totala a sejurului
                </v-btn>
              </div>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="min_stay_arrival" label="Min" type="number" class="ma-1" outlined dense hide-details :disabled="stay_read_only"/>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="max_stay_arrival" label="Max" type="number" class="ma-1" outlined dense hide-details :disabled="stay_read_only"/>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="4">
              <div class="ma-1">
                <v-btn :class="{primary: !days_advance_read_only}" depressed block style="height: 40px; font-size: small" @click="days_advance_read_only = !days_advance_read_only; min_days_advance = null; max_days_advance = null">
                  Rezervare in avans
                </v-btn>
              </div>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="min_days_advance" label="Min" type="number" class="ma-1" outlined dense hide-details :disabled="days_advance_read_only"/>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="max_days_advance" label="Max" type="number" class="ma-1" outlined dense hide-details :disabled="days_advance_read_only"/>
            </v-col>
          </v-row>

        </v-row>

      </v-card-text>

      <v-divider class="mx-2"/>

      <v-card-actions>
        <v-btn color="primary" text @click="c_dialog = false">
          Anuleaza
        </v-btn>
        <v-spacer/>
        <v-btn
          color="primary"
          depressed
          :loading="loading"
          :disabled="((!price && stop_sell===null && closed_arrival===null && closed_departure===null && !min_inventory && !max_inventory && !min_stay_arrival && !max_stay_arrival && !min_stay_through && !max_stay_through && !min_days_advance && !max_days_advance) || !days.length) || loading"
          @click="update"
        >
          Salveaza
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>


<script>

  import moment from 'moment';
  import sheet_repository from '@/repositories/sheet-repository';

  export default {
    props: {
      dialog: Boolean,
      rooms: Object,
      rates: Array,
      room: Array,
      rate: Array
    },

    data() {
      return {
        loading: false,
        menu: false,

        selected_rooms: this.room,
        available_rooms: this.rooms,

        selected_rates: this.rate,
        available_rates: this.rates,

        price: null,
        price_read_only: true,

        stop_sell: null,
        stop_sell_read_only: true,

        closed_arrival: null,
        closed_departure: null,
        closed_read_only: true,

        min_inventory: null,
        max_inventory: null,
        inventory_read_only: true,

        min_stay_through: null,
        max_stay_through: null,
        stay_through_read_only: true,

        min_stay_arrival: null,
        max_stay_arrival: null,
        stay_read_only: true,

        min_days_advance: null,
        max_days_advance: null,
        days_advance_read_only: true,

        days: [0, 1, 2, 3, 4],
        weekdays: ['Lun', 'Mar', 'Mie', 'Joi', 'Vin', 'Sâm', 'Dum'],
        from: moment().format('YYYY-MM-DD'),
        until: moment().add(1, 'days').format('YYYY-MM-DD'),
      }
    },

    computed: {

      c_dialog: {
        get() {
          return this.dialog;
        },
        set(val) {
          this.$emit('update:dialog', val);
        }
      },

      c_value: {
        get() {
          return {
            start: new Date(this.from),
            end: new Date(this.until)
          };
        },
        set(val) {
          this.from = this.$moment(val.start).format('YYYY-MM-DD');
          this.until = this.$moment(val.end).format('YYYY-MM-DD');
        }
      },

      c_label: function () {
        return this.$moment(this.c_value.start).format('LL') + ' ➞ ' + this.$moment(this.c_value.end).format('LL')
      },

      c_selected_rooms: {
        get() {
          return this.selected_rooms;
        },
        set(value) {
          this.selected_rooms = value;
          this.available_rates.splice(0, this.available_rates.length);
          this.selected_rates.splice(0, this.selected_rates.length);
          this.selected_rooms.forEach(room => {
            this.rooms[room].rate_plans.forEach(rate => {
              this.available_rates.push(rate);
            });
          });
          this.available_rates = _.uniqBy(this.available_rates, 'id');
          this.available_rates = _.sortBy(this.available_rates, 'id');
        }
      },

      c_available_rooms: {
        get() {
          return this.available_rooms;
        }
      },

      c_selected_rates: {
        get() {
          return this.selected_rates;
        },
        set(value) {
          this.selected_rates = value;
        }
      },

      c_available_rates: {
        get() {
          return this.available_rates;
        }
      }
    },

    methods: {
      update: async function () {

        let hotel = this.$route.params.hotel;
        let data = {
          period: {
            start: this.from,
            stop: this.until,
            weekdays: this.days
          },
          rooms_rates: this.getRoomRates(),
          changes: this.getChanges()
        };

        try {
          this.loading = true;
          await sheet_repository.bulkUpdatePricing(hotel, data);
          this.$emit('success');
        } catch (e) {
        } finally {
          this.loading = false
        }

      },

      resetDialog() {
        this.selected_rooms = this.room;
        this.available_rooms = this.rooms;

        this.selected_rates = this.rate;
        this.available_rates = this.rates;

        this.price = null;
        this.price_read_only = true;

        this.stop_sell = null;
        this.stop_sell_read_only = true;

        this.closed_arrival = null;
        this.closed_departure = null;
        this.closed_read_only = true;

        this.min_inventory = null;
        this.max_inventory = null;
        this.inventory_read_only = true;

        this.min_stay_through = null;
        this.max_stay_through = null;
        this.stay_through_read_only = true;

        this.min_stay_arrival = null;
        this.max_stay_arrival = null;
        this.stay_read_only = true;

        this.min_days_advance = null;
        this.max_days_advance = null;
        this.days_advance_read_only = true;

        this.days = [0, 1, 2, 3, 4];
        this.from = moment().format('YYYY-MM-DD');
        this.until = moment().add(1, 'days').format('YYYY-MM-DD');
      },

      getRoomRates() {
        let room_rates = {};
        Object.entries(this.rooms).forEach(([key, room]) => {
          this.selected_rooms.forEach(selected_room => {
            if (parseInt(selected_room) === parseInt(room.id)) {
              room.rate_plans.forEach(rate_plan => {
                this.selected_rates.forEach(selected_rate => {
                  if (parseInt(selected_rate) === parseInt(rate_plan.id)) {
                    room_rates[selected_room] = room_rates[selected_room] || [];
                    room_rates[selected_room].push(selected_rate);
                  }
                })
              })
            }
          });
        });

        return room_rates
      },

      getChanges() {
        let changes = {};

        if (this.price !== null)
          changes.price = this.price;

        if (this.stop_sell !== null)
          changes.stop_sell = this.stop_sell;

        if (this.closed_arrival !== null)
          changes.closed_arrival = this.closed_arrival;

        if (this.closed_departure !== null)
          changes.closed_departure = this.closed_departure;

        if (this.min_inventory !== null)
          changes.min_inventory = this.min_inventory;

        if (this.max_inventory !== null)
          changes.max_inventory = this.max_inventory;

        if (this.min_stay_through !== null)
          changes.min_stay_through = this.min_stay_through;

        if (this.max_stay_through !== null)
          changes.max_stay_through = this.max_stay_through;

        if (this.min_stay_arrival !== null)
          changes.min_stay_arrival = this.min_stay_arrival;

        if (this.max_stay_arrival !== null)
          changes.max_stay_arrival = this.max_stay_arrival;

        if (this.min_days_advance !== null)
          changes.min_days_advance = this.min_days_advance;

        if (this.max_days_advance !== null)
          changes.max_days_advance = this.max_days_advance;

        return changes;
      }
    }
  }
</script>